/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CompaniesInfiniteSelectField,
  InputDate,
  InputText,
} from '@/components/_common';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import {
  EmployeeCommissionListRequest,
  EmployeeCommissionSituation,
  EmployeeCommissionSituations,
} from '@/core/domain/enterprise/EmployeeCommission/EmployeeCommission.types';
import { Row, Col, Input, Select } from 'antd';
import moment from 'moment';

interface Props {
  queryParams: EmployeeCommissionListRequest;
  setQueryParams: React.Dispatch<
    React.SetStateAction<EmployeeCommissionListRequest>
  >;
}

const EmployeeCommissionsFilter: React.FC<Props> = ({
  queryParams,
  setQueryParams,
}) => {
  function handleChange(key: keyof EmployeeCommissionListRequest, value: any) {
    setQueryParams((state) => ({ ...state, [key]: value }));
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={8} lg={6}>
        <Input
          placeholder="Funcionário"
          value={queryParams.employeeName}
          onChange={({ target }) => handleChange('employeeName', target.value)}
        />
      </Col>

      <Col span={24} md={8} lg={6}>
        <Input
          placeholder="Cliente"
          value={queryParams.customerName}
          onChange={({ target }) => handleChange('customerName', target.value)}
        />
      </Col>

      <Col span={24} md={8} lg={6}>
        <Input
          placeholder="Placa"
          value={queryParams.licensePlate}
          onChange={({ target }) => handleChange('licensePlate', target.value)}
        />
      </Col>

      <Col span={24} md={8} lg={6}>
        <InputText
          onlyNumber
          placeholder="N° Orçamento"
          value={String(queryParams.codeWorkOrder || '')}
          onChange={({ target }) =>
            handleChange(
              'codeWorkOrder',
              !!target.value ? Number(target.value) : undefined,
            )
          }
        />
      </Col>

      <Col span={24} md={8} lg={5}>
        <CompaniesInfiniteSelectField
          allowClear
          placeholder="Empresa"
          value={queryParams?.companyIdFilter}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              companyIdFilter: value,
            }))
          }
        />
      </Col>

      <Col span={24} md={8} lg={6}>
        <Select
          options={Object.keys(EmployeeCommissionSituations).map(
            (key: unknown) => ({
              value: key,
              label:
                EmployeeCommissionSituations[
                  key as EmployeeCommissionSituation
                ],
            }),
          )}
          style={{ width: '100%' }}
          placeholder="Situação"
          value={queryParams.situation}
          onChange={(value) => handleChange('situation', value)}
          allowClear
        />
      </Col>

      <Col span={24} md={8} lg={6}>
        <InputDate
          disabledDate={(date) =>
            !!queryParams.to && date.isAfter(moment(queryParams.to))
          }
          placeholder="Pagamento início"
          value={queryParams.from ? moment(queryParams.from) : undefined}
          onChange={(date) => {
            if (!date) {
              handleChange('to', null);
            }
            handleChange(
              'from',
              date?.startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
            );
          }}
        />
      </Col>

      <Col span={24} md={8} lg={6}>
        <InputDate
          disabledDate={(date) =>
            !!queryParams.from && date.isBefore(moment(queryParams.from))
          }
          placeholder="Pagamento fim"
          value={queryParams.to ? moment(queryParams.to) : undefined}
          onChange={(date) => {
            if (!date) {
              handleChange('from', null);
            }
            handleChange(
              'to',
              date?.endOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
            );
          }}
        />
      </Col>

      <Col span={24} md={8} lg={6}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
};

export default EmployeeCommissionsFilter;
